import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useForm } from "../../../../hooks/useForm";
import { Grid,Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { seleccionarDetalleFacturacionSinCotizacion } from "../../../../actions/compras/AuditoriaFactura";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";

export const FormNuevoDetalleSinCotizacion = (props) =>{
    const dispatch = useDispatch(); 
    const formInicial = {
        producto: "",
        cantidad: "",
        precioUnitario: ""
    }

    const [formValues, handleInputChange] = useForm(formInicial);

    const handleSave = (e) =>{
        e.preventDefault();
        dispatch(seleccionarDetalleFacturacionSinCotizacion(formValues));
    }

    return(
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{padding:25}}>
                <Grid item xs={12} md={6}>
                <TextValidator
                        margin="normal"
                        label="Producto/Servicio"
                        name="producto"
                        value={formValues.producto}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El producto es requerido."]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                <TextValidator
                        margin="normal"
                        label="Cantidad"
                        name="cantidad"
                        value={formValues.cantidad}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required","isNumber"]}
                        errorMessages={["La cantidad es requerida."]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                <TextValidator
                        margin="normal"
                        label="Precio Unitario"
                        name="precioUnitario"
                        value={formValues.precioUnitario}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required","isNumber"]}
                        errorMessages={["El precio es requerido."]}
                    />
                </Grid>
                <Grid container style={{padding:25}} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            {
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                    onClick={props.cerrarModal}
                                >
                                    AGREGAR
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
};
export default FormNuevoDetalleSinCotizacion; 